import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDoctorsBySelectedBranchAndService, getSelected } from '../../store/selectors';
import { selectDoctor, setBookingError } from '../../store/serviceSlice';
import { GroupInput } from '../../../components/GroupInput/GroupInput';
import { START_TO_TYPE } from '../ServiceSelector/consts';

export const DoctorSelector = ({ selectedDoctorId }) => {
    const [ selectedDoctor, setSelectedDoctor ] = useState();
    const doctors = useSelector(getDoctorsBySelectedBranchAndService);
    const selected = useSelector(getSelected);
    const dispatch = useDispatch();

    useEffect(() => {
        setSelectedDoctor(selectedDoctorId ?? selected.doctors);
    }, [ selectedDoctorId, selected.doctors ]);

    const onChangeHandler = (doctorId) => {
        dispatch(setBookingError(''));
        dispatch(selectDoctor(doctorId));
    };

    const onClearHandler = () => {
        dispatch(setBookingError(''));
        dispatch(selectDoctor(''));
    };

    return <>
        <GroupInput
            id="filter_doctors"
            type="selector"
            label="Специалист"
            onChange={onChangeHandler}
            onClear={onClearHandler}
            isLoading={false}
            metaData={doctors}
            value={selectedDoctor}
            error={''}
            placeholder={START_TO_TYPE}
        />
    </>;
};
